import React from 'react';
import { CheckboxGroup, withTooltips, Accordion } from '../../components/shared';
import { updateWorkflowCoverageChange } from '../actions';
import { submission as submissionUtil } from '../../utils';

export const DEFAULT_OPTIONAL_COVERAGES = [
];

export default class OptionalCoverageSelector extends React.Component {
    constructor(props) {
        
        super(props)
        this.props = props;
        const { defaultCoverageExclusionOptions, pricingValues, value, type } = props;
        this.state = {
            options: defaultCoverageExclusionOptions,
            submission: this.props.submission,
            isPCOpsExcluded: this.props.submission.isPCOpsExcluded,
            isESWorkExcluded: this.props.submission.isESWorkExcluded,
            defaultAdditionalCoverageOptions: this.props.defaultAdditionalCoverageOptions,
        }
        this.handleChangeOption = this.handleChangeOption.bind(this)
        this.onBlurTextboxHandler = this.onBlurTextboxHandler.bind(this)
    }

    handleChangeOption(evt, selectedValues) {
        /**
         * pjones 8-19-2024: This code can probably be refactored in the future. Due to 
         * limited time I don't have time to refactor right now. I believe the setting
         * of the evt.target.dataset.optionText and calling of the onChange() handler actually
         * do something. Everything else is probably unnecessary. The isPCOpsExcluded and 
         * isESWorkExcluded are getting incorrectly set, but during the call to the handleRequote()
         * when the submission is submitted, the data is cleaned up which is why this
         * works.
         */
        evt.target.dataset.optionText = evt.target.checked;
        
        if (this.props.submission.type === "oi") {
            let updatedSubmission = this.state.submission;
            updatedSubmission.isPCOpsExcluded = evt.target.checked;
            updatedSubmission.isESWorkExcluded = evt.target.checked;
            this.setState({ isPCOpsExcluded: evt.target.checked , isESWorkExcluded: evt.target.checked});
            Object.assign(this.state.submission, updatedSubmission);
        }
        const { options } = this.state
        this.props.onChange(evt, selectedValues)
        updateWorkflowCoverageChange(evt.target.checked);
        this.setState({ options }, () => {
            this.props.updatePricingOptions(this.state.options)
        })
    }

    onBlurTextboxHandler(priceValue) {
        this.props.onBlurHandler(priceValue)
    }

    render() {
        if (this.props.type === 'ocp' && !this.props.isUnderwriter) {
            return null;
        }
        const { accordionArray, defaultCoverageExclusionOptions, isModified, manuallySetPricing, value, pricingValues } = this.props
        let updatedOptions = defaultCoverageExclusionOptions;
        let selectedArray = Object.keys(value).filter(key => !!value[key].selected).sort();
        const AccordionCheckbox = Accordion(CheckboxGroup, accordionArray);
        updatedOptions.text = this.props.isPCOpsChecked
        
        return (
            <div className="optionalCoverageSelectorContainer">
                <h4 className="quoteTitle">Coverage Exclusions</h4>
                <AccordionCheckbox
                    name="optionalCoverage"
                    options={updatedOptions}
                    value={selectedArray}
                    onChange={this.handleChangeOption}
                    isModified={isModified}
                    manuallySetPricing={manuallySetPricing}
                    onBlurTextboxHandler={this.onBlurTextboxHandler}
                />
            </div>
        )
    }
}